import { CommonModule } from '@angular/common';
import { Component, OnInit, Type, ViewChild, ViewContainerRef } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzImageModule } from 'ng-zorro-antd/image';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzStepsModule } from 'ng-zorro-antd/steps';
import { NzUploadModule } from 'ng-zorro-antd/upload';
import { QuizComponent } from '../quiz/quiz.component';
import { QuestionBuilderComponent } from '../question-builder/question-builder.component';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { QuizService } from '../quiz/quiz.service';
import { LoadingService } from 'src/app/share/services/loading.service';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';

export interface WizardStep {
  component: Type<any>;
  data?: any;
  title: string;
}

@Component({
  selector: 'app-quiz-builder',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    NzCollapseModule,
    CommonModule,
    NzButtonModule,
    NzIconModule,
    NzUploadModule,
    NzImageModule,
    NzInputModule,
    NzCardModule,
    NzFormModule,
    NzDatePickerModule,
    NzStepsModule,
    NzDropDownModule
  ],
  templateUrl: './quiz-builder.component.html',
  styleUrl: './quiz-builder.component.scss'
})
export class QuizBuilderComponent implements OnInit {
  @ViewChild('stepContainer', { read: ViewContainerRef, static: true })
  stepContainer: ViewContainerRef;

  steps: WizardStep[] = [
    { component: QuizComponent, title: 'Quiz', data: {} },
    { component: QuestionBuilderComponent, title: 'Questions', data: {} }];

  currentStep = 0;
  quizId: string = null;
  currentComponentInstance: QuizComponent;
  questionBuilderComponentInstance: QuestionBuilderComponent;
  quizData: any;
  constructor(private router: Router, private activatedRoute: ActivatedRoute, private quizService: QuizService, private loadingService: LoadingService) {

  }

  ngOnInit() {
    this.activatedRoute.params.subscribe((params: Params) => {
      this.quizId = params['id'];
      if (this.quizId) {
        this.quizService.getItemById(this.quizId).subscribe({
          next: (x: any) => {
            this.quizData = x.data;
            this.loadComponent();
          }
        })
      }
      else {
        this.loadComponent();
      }
    });

  }
  ngAfterViewInit() {

  }

  loadComponent() {
    this.stepContainer.clear();
    const step = this.steps[this.currentStep];

    // Create component dynamically
    const componentRef = this.stepContainer.createComponent(step.component);

    Object.assign(componentRef.instance, { quizId: this.quizData?.id });
    if (this.currentStep == 0) {
      this.currentComponentInstance = componentRef.instance as QuizComponent;
      if (this.quizData) {
        this.currentComponentInstance.quizData = this.quizData;
      }
    }
    else {
      this.questionBuilderComponentInstance = componentRef.instance as QuestionBuilderComponent;
      // Pass data to the component instance

      this.questionBuilderComponentInstance.quizId = this.quizData.id;
      this.questionBuilderComponentInstance.type = 'final';
    }
    // Handle component events
    if (componentRef.instance['next']) {
      componentRef.instance['next'].subscribe(() => this.next());
    }
    if (componentRef.instance['prev']) {
      componentRef.instance['prev'].subscribe(() => this.prev());
    }
  }

  next() {
    this.currentComponentInstance.updateValidity();
    if (this.currentComponentInstance.quizform.valid) {
      this.quizData = this.currentComponentInstance.quizform.value;
      this.loadingService.showLoading();
      if (this.quizData.id) {
        this.loadingService.hideLoading();
        if (this.currentStep < this.steps.length - 1) {
          this.currentStep++;
          this.loadComponent();
        }
      }
      else {
        this.quizService.createItem(this.quizData).subscribe({
          next: (x: any) => {
            this.quizData = x.quiz;
            if (this.currentStep < this.steps.length - 1) {
              this.currentStep++;
              this.loadComponent();
            }
          },
          error: (err: any) => {
            console.log(err);
          },
          complete: () => { this.loadingService.hideLoading(); }
        });
      }
    }
  }

  prev() {
    if (this.currentStep > 0) {

      this.currentStep--;
      this.loadComponent();
    }
  }

  done(status:string=null) {
    if(status){
      this.quizData.status=status;
    }
    this.loadingService.showLoading();
    this.quizService.updateItem(this.quizData).subscribe({
      next: (x: any) => {
        this.loadingService.hideLoading();
      },
      error: (error: any) => {
        console.log(error);
        this.loadingService.hideLoading();

      },
      complete: () => {
        this.loadingService.hideLoading();
        this.router.navigate(['/quizlist']);
      }
    });
  }
}
